<app-grid>
  <app-info-area>
      <h3 class="pb-4 text-primary text-xl font-bold dark:text-white">The Lacuna LoneWhisper Almanac</h3>
      <p>In case you want to download the latest LoneWhisper almanac, you can preview or copy the format you like.</p>
      <div>
        <h4 class="font-bold text mt-8 mb-1"><i style="margin-right:2px;">multi</i>Node CLI commands</h4>
        <p>Use this format if you want to insert the almanac using the CLI on the <i style="margin-right:2px;">multi</i>Node. <br><br>Note that each command (5 total) should be entered individually.</p>
        <div class="mt-2">
          <button class="btn btn-primary btn-sm" (click)="previewAlmanac('ls300-cli')">Preview</button>
        </div>
      </div>
    <div tabindex="0" class="collapse collapse-arrow bg-base-100 border-base-200 border mt-6">
      <div class="collapse-title font-semibold">Other formats</div>
      <div class="collapse-content text-sm">
        <div>
          <h4 class="font-bold text mt-8 mb-1">C source code</h4>
          <p>Use this format if you want to copy paste the almanac data along the Arduino sketch.</p>
          <div class="mt-2">
            <button class="btn btn-primary mr-3 btn-sm mb-2" (click)="previewAlmanac('c-code')">Preview</button>
            <button class="btn btn-primary btn-sm mb-2" (click)="copy('c-code')">Copy to clipboard</button>
          </div>
        </div>
        <div>
          <h4 class="font-bold text mt-8 mb-1">Hexadecimal code</h4>
          <p>Use this format if you want to copy paste the almanac data in hex format.</p>
          <div class="mt-2">
            <button class="btn btn-primary mr-3 btn-sm mb-2" (click)="previewAlmanac('binary')">Preview</button>
            <button class="btn btn-primary btn-sm mb-2" (click)="copy('binary')">Copy to clipboard</button>
          </div>
        </div>
      </div>
    </div>

  </app-info-area>
  <app-content-area>
      @if(previewingAlmanac != null){
        <h3 class="pt-6 pb-4 text-primary text-xl font-bold dark:text-white">The Lacuna LoneWhisper Almanac</h3>
        <p class="break-all whitespace-pre-line font-mono text-sm  mb-2">{{previewingAlmanac}}</p>
      }
  </app-content-area>
</app-grid>
